<p class="helppoint-title">{{data.title}}</p>
<p class="helppoint-text">{{data.text}}</p>
<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirm()" color="primary">{{'CONFIRM.BUTTON' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()" color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>